import {THEME_COLORS} from './_colors'

export const THEME_SEMANTICS = {
  primary: THEME_COLORS.primary_500,
  secondary: THEME_COLORS.secondary_500,
  gray: THEME_COLORS.gray_900,
  failed: THEME_COLORS.red_500,
  preparing: THEME_COLORS.orange_500,
  delivering: THEME_COLORS.blue_500,
  delivered: THEME_COLORS.green,
  link: THEME_COLORS.blue_400,
}
